<template>
  <div>
    <v-tour name="HelpTour" :steps="HelpTourSteps" :options="HelpTourOptions">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.steps[tour.currentStep]"
            :key="tour.currentStep"
            :step="tour.steps[tour.currentStep]"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :skip="tour.skip"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
            :highlight="tour.highlight"
          >
            <template>
              <!-- <div slot="content">
                <div
                  v-if="!tour.isLast && !tour.currentStep == 0"
                  @click="tour.skip"
                  class="caption text-right"
                >
                  <v-icon small color="white">mdi-close-circle</v-icon>
                </div>
                <div v-html="tour.steps[tour.currentStep].content"></div>
              </div> -->

              <div slot="actions">
                <button
                  @click="tour.previousStep"
                  v-if="!tour.isFirst"
                  class="v-step__button v-step__button-previous"
                >
                  <v-icon small color="white">mdi-chevron-left</v-icon>
                </button>
                <button
                  @click="tour.nextStep"
                  v-if="!tour.isLast"
                  class="v-step__button v-step__button-next"
                >
                  <v-icon small color="white">mdi-chevron-right</v-icon>
                </button>
                <button
                  @click="tour.finish"
                  v-if="tour.isLast"
                  class="v-step__button v-step__button-stop"
                >
                  Ende
                </button>
                <button
                  @click="tour.skip"
                  v-if="!tour.isLast"
                  class="v-step__button v-step__button-skip"
                >
                  <v-icon small color="white">mdi-close</v-icon>
                </button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
    <!--   navi menü abschnitt-->
    <v-navigation-drawer v-model="navMenu" app disable-resize-watcher>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-btn color="primary" class="my-4" @click="backToObjekte">
              <v-icon>mdi-arrow-left-circle</v-icon>
            </v-btn>
            <v-list-item-title class="text-h6">
              Mieter Portal
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ loginEmail }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/Benutzerkonto">
          <v-list-item-icon>
            <v-icon large>mdi-account</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Benutzerkonto</v-list-item-title>
        </v-list-item>

        <v-list-item link to="/meineObjekte">
          <v-list-item-icon>
            <v-icon large>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Vertragsobjekte</v-list-item-title>
        </v-list-item>

        <v-list-item class="px-2">
          <v-list-item-avatar>
            <v-img :src="selectedObjekt.src"></v-img>
          </v-list-item-avatar>
          <v-icon>{{ selectedObjekt.topart }}</v-icon>
          <v-spacer></v-spacer>
        </v-list-item>

        <v-list-item link>
          <v-list-item-content>
            <v-list-item-title class="title">
              {{ selectedObjekt.title }}
            </v-list-item-title>
            <v-list-item-subtitle>{{
              selectedObjekt.infotext
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <!-- 
      <v-divider></v-divider>

      <v-list
        nav        
      >

        <v-list-item-group
          v-model="aktivesDrawerElement"
          color="primary"
        >
          <v-list-item link to="/meineObjekte">
            <v-list-item-icon>
              <v-icon  large>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Vertragsobjekte</v-list-item-title>
            
          </v-list-item>          
          <v-list-item @click="navToDokumente">
            <v-list-item-icon>
              <v-icon  large>mdi-file-document-multiple</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Dokumente</v-list-item-title>
            
          </v-list-item>
          <v-list-item link to="/meineTermine">
            <v-list-item-icon  >
              <v-badge
                color="primary"
                :content=countNewTermine
                left
                overlap
                v-model="countNewTermine"
              >
                <v-icon large>mdi-calendar</v-icon>
              </v-badge>              
            </v-list-item-icon>
            <v-list-item-title >Termine</v-list-item-title>
            
          </v-list-item>
          <v-list-item link to="/meineBenachrichtigungen">
            <v-list-item-icon>
              <v-badge
                color="primary"
                :content=countNewBenachrichtigungen
                left
                overlap
                v-model="countNewBenachrichtigungen"
              >
                <v-icon large>mdi-message-text</v-icon>
              </v-badge>              
            </v-list-item-icon>
            <v-list-item-title>Benachrichtigungen</v-list-item-title>
            
          </v-list-item>
        </v-list-item-group>
      </v-list> -->
    </v-navigation-drawer>
    <!--   navi menü abschnitt-->

    <!--   Header -->
    <v-app-bar app>
      <v-badge
        v-if="routeLoggedIn"
        color="primary"
        :content="countNewElemente"
        left
        overlap
        :value="countNewElemente"
      >
        <v-app-bar-nav-icon
          large
          @click.stop="switchNavMenu"
          ref="navButton"
          class="v-step-200"
        >
        </v-app-bar-nav-icon>
      </v-badge>

      <img
        class="mx-auto"
        src="@/assets/logo_oerag_immobilien.svg"
        height="50"
      />
      <!--   logout abschnitt -->
      <div v-if="routeLoggedIn">
        <v-icon class="mr-4 v-step-0" large color="primary" @click="startTour"
          >mdi-help-circle</v-icon
        >
        <v-dialog v-model="logoutConfirmed" persistent max-width="400">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark v-bind="attrs" v-on="on">
              <v-icon>mdi-logout</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title class="headline"> Logout </v-card-title>
            <v-card-text
              >Möchten Sie aus dem Portal wirklich ausloggen?</v-card-text
            >
            <v-card-actions>
              <v-btn color="primary darken-1" text @click="logoutCall">
                <v-icon>mdi-check-circle</v-icon>
                JA
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="primary darken-1"
                text
                @click="logoutConfirmed = false"
              >
                <v-icon>mdi-close-circle</v-icon>
                NEIN
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>

      <!--   logout abschnitt -->
    </v-app-bar>
    <!--   Header -->
  </div>
</template>
<style>
.v-step[data-v-54f9a632] {
  background: #2a67eb !important;
}

.v-step__arrow--dark[data-v-54f9a632]:before {
  background: #1e15a0 !important;
}

.v-step__header[data-v-54f9a632] {
  background-color: #1e15a0 !important;
}

.v-tour__target--highlighted {
  -webkit-box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.4) !important;
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.4) !important;
}

.v-step__button {
  padding: 0.35rem 1.1rem !important;
}
.v-step__button[data-v-54f9a632]:hover {
  background-color: rgba(22, 46, 185, 0.95) !important;
  color: #ffffff !important;
}
</style>
<script>
import { mdiFileDocumentMultiple } from "@mdi/js";

export default {
  data: () => ({
    svgDocuments: mdiFileDocumentMultiple,
    Mietername: "Helga Karl",
    navMenu: false,
    // aktivesDrawerElement: 0,
    logoutConfirmed: false,
    HelpTourSteps: [{ before: undefined }],
    HelpTourOptions: {
      highlight: true,
      enabledButtons: {
        buttonSkip: true,
        buttonPrevious: true,
        buttonNext: true,
        buttonStop: false,
      },
    },
  }),
  methods: {
    startTour() {
      this.$nextTick(() => {
        let steps = {
          VertragsObjekte: [
            {
              target: ".v-step-100",
              header: {
                title: "Hilfe",
              },
              content:
                "Wir zeigen Ihnen in </br>wenigen Schritten<br>die wichtigsten Funktionen</br> im Mieterportal.</br></br> Legen wir los!",
              params: { placement: "top" },
            },
            {
              target: ".v-step-110",
              content: "Zu jedem Mietobjekt</br> wählen Sie Ihre Aktion.",
              params: { placement: "top" },
            },
            {
              target: ".v-step-130",
              content: "Mietvertrag, </br>Vorschreibung, etc. einsehen. ",
              params: { placement: "top" },
            },
            {
              target: ".v-step-140",
              content:
                "Termine für Mietvertragsunterschrift und Mietobjektübergabe.</br></br>Bestätigen und direkt </br>in Ihren Kalender</br>aufnehmen.",
              params: { placement: "top" },
            },
            {
              target: ".v-step-150",
              content:
                "SEPA Lastschriftdaten,</br>Post Zustelladresse</br>und Meldezettel-Formular</br>verwalten.",
              params: { placement: "top" },
            },
            {
              target: ".v-step-160",
              content: "News zu Ihrer </br>Liegenschaft ansehen.",
              params: { placement: "top" },
            },
            {
              target: ".v-step-170",
              content:
                "Schadensmeldungen vornehmen</br>und Bearbeitungsstatus anzeigen.",
              params: { placement: "top" },
            },
            {
              target: ".v-step-180",
              content: "Notfallnummern</br>anzeigen.",
              params: { placement: "top" },
            },
            {
              target: ".v-step-200",
              content:
                "Im Menü </br>Benutzerkonto</br> verwalten Sie Ihre</br>E-Mail Adresse</br> und Ihr</br> Passwort",
              params: { placement: "top" },
            },
            {
              target: ".v-step-0",
              content:
                "Zum Abschluss!</br></br>Nutzen Sie die</br> Hilfe</br>&#x1F60a;</br></br>Sie bekommen immer</br>Infos für</br>jenen Bereich,</br> in dem Sie sich befinden.</br></br>Ihre</br>ÖRAG | Liegenschaftsverwaltung",
              params: { placement: "top" },
            },
          ],
          Benutzerkonto: [
            {
              target: ".v-step-300",
              header: {
                title: "Hilfe - Benutzerkonto",
              },
              content:
                "Hier verwalten Sie Ihre Login Daten</br></br><strong>Passwort</strong></br><strong>E-Mail</strong></br><strong>Mobilnummer</strong></br><strong>Telefonnummer</strong></br></br>Halten sie Ihre Mobilnummer stets aktuell!</br></br>So können wir Sie im Bedarfsfall kontaktieren!<br>",
              params: { placement: "top" },
            },
          ],
          Notfall: [
            {
              target: ".v-step-400",
              header: {
                title: "Hilfe - Notfall Kontaktliste",
              },
              content:
                "Rufen Sie direkt an!</br></br>Im Notfall</br>sind alle wichtigen</br>Kontakte für Sie mit einem Klick</br>erreichbar.",
              params: { placement: "top" },
            },
          ],
          Schadensfall: [
            {
              target: ".v-step-500",
              header: {
                title: "Hilfe - Schadensfall",
              },
              content:
                "Schäden am Haus oder</br> in der Wohnung</br>schnellstmöglich beheben.</br></br>Wir zeigen Ihnen</br>in 3 Schritten</br>wie Sie das</br>umgehend melden.</br></br>Legen wir los!",
              params: { placement: "top" },
            },
            {
              target: ".v-step-510",
              content: "..Haus oder Top auswählen",
              params: { placement: "top" },
            },
            {
              target: ".v-step-510",
              content: "...noch einen Schritt auswählen",
              params: { placement: "top" },
            },
            {
              target: ".v-step-510",
              content: "...und der letzte Schritt :)",
              params: { placement: "top" },
            },
          ],
          Termine: [
            {
              target: ".v-step-600",
              header: {
                title: "Hilfe - Termine",
              },
              content:
                "Ihre Termine für die Vertragsunterzeichnung und die Übergabe find Sie hier!</br></br>",
              params: { placement: "bottom" },
            },
            {
              target: ".v-step-610",
              content: "Hier steht der Terminzeitpunkt.</br></br> ",
              params: { placement: "bottom" },
            },
            {
              target: ".v-step-615",
              content:
                "Der Terminstatus</br></br>Bestätigt oder Reserviert</br></br>",
              params: { placement: "bottom" },
            },
            {
              target: ".v-step-620",
              content:
                "Aktives Zusagen</br>oder</br> zur Kenntnis nehmen</br>(bei mehreren Mietern)</br>per Klick.</br></br>",
              params: { placement: "bottom" },
            },
            {
              target: ".v-step-630",
              content:
                "Hier</br>übernehmen Sie optional</br>den Termin direkt in </br>Ihren Kalender</br></br>",
              params: { placement: "bottom" },
            },
          ],
          Dokumente: [
            {
              target: ".v-step-700",
              header: {
                title: "Hilfe - Dokumente",
              },
              content:
                "Alle Ihre Dokumente</br>finden Sie hier gelistet!</br></br>",
              params: { placement: "top" },
            },
            {
              target: ".v-step-705",
              content: "Zur schnellen Suche</br>den Suchtext hier eingeben.",
              params: { placement: "top" },
            },
            {
              target: ".v-step-710",
              content:
                "Klick auf eine Zeile</br>zeigt das Dokument</br>im Viewer an.",
              params: { placement: "top" },
            },
            {
              target: ".v-step-720",
              content:
                "Klick auf das Icon</br>startet den Download</br>des Dokuments.",
              params: { placement: "top" },
            },
          ],
          Benachrichtigungen: [
            {
              target: ".v-step-800",
              header: {
                title: "Hilfe - Benachrichtigungen",
              },
              content:
                "Aktuelle Infos zu Themen</br>wie zB. Wartungen, Reinigung oder</br>Allgemeine Punkte</br>werden hier aufgelistet.</br></br>",
              params: { placement: "top" },
            },
          ],
          meineDaten: [
            {
              target: ".v-step-900",
              header: {
                title: "Hilfe - Meine Daten",
              },
              content:
                "Hier verwalten sie SEPA Lastschrift Daten, die Postzustelladresse und bei Wohnungen das Formular des Meldezettels",
              params: { placement: "top" },
            },
            {
              target: ".v-step-910",
              content:
                "Postzustelladresse</br></br>Dient als Adresse wenn wir Schriftstücke versenden.",
              params: { placement: "top" },
            },
            {
              target: ".v-step-920",
              content:
                "SEPA Daten</br></br>Wird nicht für die</br> Kaution und 1. Vorschreibung</br> verwendet!",
              params: { placement: "top" },
            },
            {
              target: ".v-step-930",
              content:
                "Meldezettel</br></br>Mit Basisdaten befüllt um Ihre Ummeldung zu erleichtern!",
              params: { placement: "top" },
            },
          ],
        };

        let showSteps = [];
        let tourSteps = steps[this.$route.name] || [];
        // Nur angezeigte Elemente des DOM in die Tour aufnehmen
        if (tourSteps.length) {
          for (let ind = 0; ind < tourSteps.length; ind++) {
            if (document.querySelector(tourSteps[ind].target)) {
              showSteps.push(tourSteps[ind]);
            }
          }
        }
        this.HelpTourSteps = showSteps;

        this.$tours["HelpTour"].start();
      });
    },
    logoutCall() {
      this.logoutConfirmed = false;
      this.$store.commit("setMieterOid", "");
      this.$store.commit("setToken", "");
      //this.$router.push({name: 'Login'})
      window.sessionStorage.clear();
      window.localStorage.clear();
      window.location.replace("/login");
    },
    backToObjekte() {
      this.navMenu = false;
      if (this.$route.name != "VertragsObjekte") {
        this.$route.push({ name: "VertragsObjekte" });
      }
    },
    switchNavMenu() {
      // if (this.$route.name=='ObjektDaten') {
      //   this.navMenu=!this.navMenu
      // }
      this.navMenu = !this.navMenu;
    },
  },
  mounted() {
    // kein Vorgang
  },
  computed: {
    countNewBenachrichtigungen: function () {
      return this.$store.state.countNewBenachrichtigungen;
    },
    countNewTermine: function () {
      return this.$store.state.countNewTermine;
    },
    countNewElemente: function () {
      return this.$store.getters.countNewElemente;
    },
    selectedObjekt: function () {
      return this.$store.state.selectedObjekt;
    },
    loginEmail: function () {
      return this.$store.state.loginEmail;
    },
    routeLoggedIn: function () {
      var hideLogoutButtonOnRoutes = [
        "Login",
        "Registrierung",
        "Passwort-Reset anfordern",
        "Passwort zurücksetzen",
        "Übergabe",
      ]; //Route Namen sind definiert in /router/index.js
      return hideLogoutButtonOnRoutes.indexOf(this.$route.name) > -1
        ? false
        : true;
    },
  },
};
</script>
